const normalizeSearchValue = (value) => {
  return String(value || "")
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .trim();
};

export const getLevenshteinDistance = (source = "", target = "") => {
  const sourceValue = normalizeSearchValue(source);
  const targetValue = normalizeSearchValue(target);

  if (sourceValue === targetValue) return 0;
  if (!sourceValue.length) return targetValue.length;
  if (!targetValue.length) return sourceValue.length;

  const previousRow = Array.from(
    { length: targetValue.length + 1 },
    (_, index) => index,
  );

  for (let sourceIndex = 0; sourceIndex < sourceValue.length; sourceIndex += 1) {
    const currentRow = [sourceIndex + 1];

    for (let targetIndex = 0; targetIndex < targetValue.length; targetIndex += 1) {
      const insertionCost = currentRow[targetIndex] + 1;
      const deletionCost = previousRow[targetIndex + 1] + 1;
      const substitutionCost =
        previousRow[targetIndex] +
        (sourceValue[sourceIndex] === targetValue[targetIndex] ? 0 : 1);

      currentRow.push(
        Math.min(insertionCost, deletionCost, substitutionCost),
      );
    }

    previousRow.splice(0, previousRow.length, ...currentRow);
  }

  return previousRow[targetValue.length];
};

const isFuzzyMatch = (candidate, searchTerm) => {
  const candidateValue = normalizeSearchValue(candidate);
  const query = normalizeSearchValue(searchTerm);

  if (!query) return true;
  if (!candidateValue) return false;
  if (candidateValue.includes(query)) return true;

  const candidateWords = candidateValue.split(/\s+/).filter(Boolean);
  const queryWords = query.split(/\s+/).filter(Boolean);

  return queryWords.every((queryWord) =>
    candidateWords.some((candidateWord) => {
      const distance = getLevenshteinDistance(candidateWord, queryWord);
      const maxDistance = queryWord.length <= 4 ? 1 : 2;
      return distance <= maxDistance;
    }),
  );
};

export const fuzzySearchRows = (rows = [], searchTerm = "", searchKeys = []) => {
  const query = normalizeSearchValue(searchTerm);
  if (!query || !searchKeys.length) return rows;

  return rows.filter((row) =>
    searchKeys.some((key) => isFuzzyMatch(row[key], query)),
  );
};
